import { Box, Container, Grid, Typography } from "@mui/material";
import { Button } from "@pancakeswap/uikit";
import styled from "styled-components";
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { useEffect, useState } from "react";
import FarmTabButtons from "./components/FarmTabButton";
import PoolsTable from "views/Pools/components/PoolsTable/PoolsTable";
import { useWeb3React } from "@web3-react/core";
import FarmCard from "./components/FarmCard";
import { BigNumber, ethers } from "ethers";
import MulticallABI from "ABI/MulticallABI.json";
import { multicallv2 } from "utils/multicall";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import TokenABI from "ABI/TokenABI.json";
import DrivenFarmABI from "ABI/DrivenFarmABI.json";
import UniRouterABI from "ABI/UniRouterABI.json";
import LpTokenABI from "ABI/LpTokenABI.json";
import ERC20ABI from "ABI/ERC20ABI.json";

import {
    getLockUpAddress,
    getMulticallAddress,
    getTokenAddress,
    getDrivenFarmAddress,
    getWBNBAddress,
    getRouterAddress,
    getUSDTAddress
} from "utils/addressHelpers";
import { PoolData } from "config/constants/types";
import FarmsTable from "./components/FarmsTable/FarmsTable";
import { getContract } from "utils/contractHelpers";
import contractAddress from "../../constants/contract";
import { useDispatch, useSelector } from "react-redux";
import { setIdx } from "store/IndexSlice";
import FarmRoiCalculatorModal from "views/Pools/components/Modal/FarmRoiCalculatorModal";
import dvx_header from '../../assets/images/dvx_header.png'
import bnb_header from '../../assets/images/bnb_header.png'
import busd_img from '../../assets/images/busd_img.png'
import { BNBImg, BusdImg, DVXImg } from "views/Pools";

const PoolsData = styled.div`
  margin-right: 2rem;
  margin-left: 2rem;
  max-width : 1150px;
  width : 100%;
`;

const PoolControls = styled.div`
  display: flex;
  max-width: 100%;
  align-items: center;
  position: relative;
    // justify-content:start;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 32px;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 16px 32px;
    margin-bottom: 0;
  }
`;

const userDataLoaded = false;

// let pools: PoolData[] = [
//     {
//         contractType: "lockup",
//         stackType: 0,
//         user: {
//             tokenbalance: "0",
//             userstack: "-1"
//         }
//     },
//     {
//         contractType: "lockup",
//         stackType: 1,
//         user: {
//             tokenbalance: "0",
//             userstack: "-1"
//         }
//     },
//     {
//         contractType: "lockup",
//         stackType: 2,
//         user: {
//             tokenbalance: "0",
//             userstack: "-1"
//         }
//     },
// ];

// const calAPY = (lockupRate, precisionFactory, totalStacked) => {
//     if (totalStacked.toString() == '0')
//         return BigNumber.from("0");
//     const rewardPerBlock = (lockupRate.mul(precisionFactory)).div(totalStacked);
//     const blockPerYear = BigNumber.from(`${2878 * 365}`);
//     return rewardPerBlock.mul(blockPerYear)
// }


let map, pricemap;
const Farms: React.FC = () => {

    // useEffect(()=>{
    //     document.title='Farms | DRIVENswap V2.0'
    // });

    const idx = useSelector((state: any) => state.Index.idx)
    const pidx = useSelector((state: any) => state.Index.processidx);

    const [allpooldata, setPoolData] = useState([]);
    const [filteredPool, setfilteredPool] = useState([]);
    const [searchvalue, setSearchValue] = useState('');

    const [istoggleview, setIsToggleview] = useState(true)
    const [updateUser, setUpdateUser] = useState(false);

    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();

    const dispatch = useDispatch()

    const handleClose = () => {
        dispatch(setIdx(-1))
    }

    const stackChange = (isStackedChange, isLive, handleSortOptionChange, searchvalue) => {
        let temp = allpooldata.filter(ele => {
            return ((isStackedChange && parseFloat(ele.user.stakeamount) > 0) || !isStackedChange) && (isLive) && ((ele.token0Symbol).toLowerCase().includes((searchvalue).toLowerCase()) || (ele.token1Symbol).toLowerCase().includes((searchvalue).toLowerCase()))
        });
        if (handleSortOptionChange === 'liquidity') {
            temp = temp.sort((ele1, ele2) => parseInt(ele2.liquidity) - parseInt(ele1.liquidity));
        } else if (handleSortOptionChange === 'earned') {
            temp = temp.sort((ele1, ele2) => (parseFloat(ele2.user.pendingreward) - parseFloat(ele1.user.pendingreward)));
        } else if (handleSortOptionChange === 'apr') {
            temp = temp.sort((ele1, ele2) => parseInt(ele2.apr) - parseInt(ele1.apr));
        } else if (handleSortOptionChange === 'hot') {
            temp = temp.sort((ele1, ele2) => parseInt(ele2.endsin) - parseInt(ele1.endsin));
        }
        setfilteredPool(temp);
    }

    const drivenFarmaddress = getDrivenFarmAddress();
    const wbnbTokenaddress = getWBNBAddress();
    const usdtToken = getUSDTAddress();
    const routerContractaddress = getRouterAddress();
    // const dispatch = useDispatch();

    const routerContract = getContract(UniRouterABI, routerContractaddress);
    const farmContract = getContract(DrivenFarmABI, drivenFarmaddress);
    const fetchInfo = async () => {

        const poolLen = await farmContract.poolLength();
        // console.log(poolLen.toString());

        let call = Array(parseInt(poolLen.toString())).fill("poolInfo").map((method, index) => ({
            address: drivenFarmaddress,
            name: method,
            params: [index],
        }))

        const result = await multicallv2(
            DrivenFarmABI,
            call
        );
        const lpTokesArr = result.map(ele => ele.lpToken);

        call = lpTokesArr.map(addr => {
            return {
                address: addr,
                name: "token0"
            }
        })

        call = [...call, ...lpTokesArr.map(addr => {
            return {
                address: addr,
                name: "token1"
            }
        })]

        const lpTokenResult = await multicallv2(
            LpTokenABI,
            call
        );
        const tokens01 = lpTokenResult.map(ele => ele[0])

        let tokens = [...tokens01, ...lpTokesArr]
        const setToken = new Set(tokens);

        let symbolCall = [];

        setToken.forEach((addr) => {
            symbolCall.push({
                address: addr,
                name: 'symbol'
            });
            symbolCall.push({
                address: addr,
                name: 'decimals'
            });
        })
        const tokenDetails = await multicallv2(
            ERC20ABI,
            symbolCall
        );

        map = new Map();
        pricemap = new Map();
        let index = 0;
        setToken.forEach(async (addr) => {

            map.set(addr, { symbol: tokenDetails[index][0], decimal: tokenDetails[index + 1][0] });
            // console.log(index);
            index += 2;
        })
        let idx = 0;
        tokens01.map(async (addr) => {
            let arrayInput = []
            let setval = 1;
            if (addr.toLowerCase() == wbnbTokenaddress.toLowerCase()) {
                arrayInput = [addr, usdtToken]
            } else {
                arrayInput = [addr, wbnbTokenaddress, usdtToken]
                setval = 2
            }
            let tknprice = (await routerContract.getAmountsOut(ethers.utils.parseUnits("1", tokenDetails[idx + 1][0]), arrayInput))[setval];
            pricemap.set(addr, { price: ethers.utils.formatUnits(tknprice.toString(), tokenDetails[idx + 1][0]) })
            idx += 2;
        })
        const pool = []
        let i = 0;
        let pId = 0;
        let j = i + tokens01.length / 2;
        let k = j + j;
        const WBNB = wbnbTokenaddress.toLowerCase();
        let paircall = lpTokesArr.map(addr => {
            return {
                address: addr,
                name: "getReserves"
            }
        })
        paircall = [...paircall, ...lpTokesArr.map(addr => {
            return {
                address: addr,
                name: "totalSupply"
            }
        }), ...lpTokesArr.map(addr => {
            return {
                address: addr,
                name: "balanceOf",
                params: [drivenFarmaddress]
            }
        })]

        const pairContract = await multicallv2(
            LpTokenABI,
            paircall
        ); 
        const yearlyblock = BigNumber.from((365 * 28782).toString());
        const rewardPerBlock =  await farmContract.rewardPerBlock();
        const totalAllocPoint =  await farmContract.totalAllocPoint();
        const pairResult = pairContract.map(ele => ele)
        result.map((ele) => {
            const token0Addr = tokens01[i];
            const token1Addr = tokens01[j];
            const token0Symbol = map.get(token0Addr).symbol;
            const token1Symbol = map.get(token1Addr).symbol;
            const token0Decimal = map.get(token0Addr).decimal;
            const token1Decimal = map.get(token1Addr).decimal;
            const token0Price = pricemap.get(token0Addr).price; //WBNB
            const token1Price = pricemap.get(token1Addr).price;
            const lpTokenDecimal = map.get(ele.lpToken).decimal;
            const allocationPoint = ele.allocPoint;
            const token0Reserve = pairResult[i][0];  //WBNB
            const token1Reserve = pairResult[i++][1];
            const lpTokenSupply = pairResult[j++][0];
            const balanceOfLPToken = pairResult[k++][0];
            
        
            let tokenAddr;
            let wbnb;
            let tokenDecimal;
            let tokenSymbol;
            if (WBNB == token0Addr.toLowerCase()) {
                tokenAddr = token1Addr
                wbnb = token0Addr;
                tokenDecimal = token1Decimal;
                tokenSymbol = token1Symbol;
            } else {
                tokenAddr = token0Addr
                wbnb = token1Addr
                tokenDecimal = token0Decimal;
                tokenSymbol = token0Symbol;
            }
            let RSV = (parseFloat(ethers.utils.formatUnits(token0Reserve.toString(), token0Decimal)) * 2) / parseFloat(ethers.utils.formatUnits(lpTokenSupply.
                toString(), lpTokenDecimal)) 
            const lptokenPrice = (RSV) * (token0Price);
            let liquidity = (parseFloat(ethers.utils.formatUnits(balanceOfLPToken.toString(), lpTokenDecimal)) * RSV * (parseFloat(token0Price.toString())));
            const ratio = token0Price / lptokenPrice;
            let apr = 100*(parseFloat(rewardPerBlock.toString())*parseFloat(yearlyblock.toString()))/(parseFloat(balanceOfLPToken.toString())*(parseFloat(allocationPoint.toString())/(parseFloat(totalAllocPoint.toString())*ratio)))
   
            pool.push({
                lpToken: ele.lpToken,
                wbnb,
                tokenAddr,
                token0Symbol,
                token1Symbol,
                token0Addr,
                token1Addr,
                token0Decimal,
                token1Decimal,
                tokenSymbol,
                lpTokenDecimal,
                pId,
                allocationPoint,
                token0Reserve,
                token1Reserve,
                lpTokenSupply,
                balanceOfLPToken,
                token0Price,
                token1Price,
                liquidity,
                lptokenPrice,
                apr,
                RSV,
            })
            pId++;
        })
        setfilteredPool(pool);
        setPoolData(pool)
        // console.log("pools", pool);
        setUpdateUser(!updateUser);
    };

    useEffect(() => {
        fetchInfo();
        console.log("pools");
    }, []);

    // useEffect(() => {
    //     fetchInfo();
    //     console.log("pools pidx");
    // }, [pidx]);

    useEffect(() => {
        if (account) {
            const userPool = [...allpooldata];
            let FarmContractCall = [];
            let lpTokenContractCall = [];
            const FarmAddress = drivenFarmaddress;
            // userPool.forEach((pool) => {
            let pId = 0;
            for (let pool of userPool) {

                FarmContractCall.push(
                    ...["pendingRewards"].map((method) => ({
                        address: FarmAddress,
                        name: method,
                        params: [pId, account]
                    }))
                );
                FarmContractCall.push(
                    ...["userInfo"].map((method) => ({
                        address: FarmAddress,
                        name: method,
                        params: [pId, account]
                    }))
                );
                lpTokenContractCall.push(
                    ...["balanceOf"].map((method) => ({
                        address: pool.lpToken,
                        name: method,
                        params: [account]
                    }))
                );
                pId++;
            }
            const fetchUserInfo = async () => {
                const farmContractData = await multicallv2(
                    DrivenFarmABI,
                    FarmContractCall
                );
                const lpTokenContractData = await multicallv2(
                    LpTokenABI,
                    lpTokenContractCall
                );
                // userPool.forEach(async (pool) => {
                let index = 0;
                for (let pool of userPool) {
                    // pool.user.userstack = farmContractData[(pool.stackType) * 2][0].toString();
                    pool.user = {
                        pendingreward: farmContractData[index][0],
                        stakeamount: farmContractData[index + 1][0],
                        lpTokenBalance: lpTokenContractData[index / 2][0]
                    }
                    index += 2;
                };
                console.log("All Pool Data", userPool)
                setPoolData(userPool);
                setfilteredPool(userPool)
            }
            fetchUserInfo();
            // setInterval(fetchInfo, 5000);
            console.log("All Pool Data");
        }
    }, [account, updateUser]);

    return (
        <>
            <Box sx={{ background: '#000B22' }}>
                <Container>
                    <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'center', md: 'start', lg: 'start' }, flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' } }}>
                        <Box sx={{ pt: 4, pb: 5, color: 'white', display: 'flex', flexDirection: 'column', mr: { xs: 0, sm: 0, md: 8, lg: 8 }, flex: '1 1 0%', maxWidth: { xs: '100%', sm: '100%', md: '50%', lg: '50%' } }}>
                            <Typography sx={{ fontSize: { xs: '1.25rem', sm: '1.25rem', md: '2.75rem', lg: '2.75rem' }, lineHeight: 2, textTransform: 'uppercase', fontWeight: 'bold', display: { xs: 'flex', sm: 'flex', md: 'block', lg: 'block' }, justifyContent: { xs: 'center', sm: 'center', md: 'start', lg: 'start' } }}>
                                Farms
                            </Typography>
                            <Typography sx={{ fontSize: '1rem', mt: 1, color: 'rgb(177, 179, 203)', textAlign: { xs: 'center', sm: 'center', md: 'start', lg: 'start' } }}>
                                Stake your tokens in a range of projects to earn passive income.
                            </Typography>
                            {/* <Box>
                                    High APR, low risk.
                                </Box> */}
                            <Box sx={{ mt: 2, maxWidth: { xs: '100%', sm: '100%', md: '60%', lg: '60%' }, display: { xs: 'flex', sm: 'flex', md: 'block', lg: 'block' }, justifyContent: { xs: 'center', sm: 'center', md: 'start', lg: 'start' } }}>
                                <Box sx={{ display: 'flex', position: 'relative', backgroundColor: 'rgb(255, 255, 255)', borderRadius: '16px', boxShadow: 'rgb(14 14 44 / 10%) 0px 20px 36px -8px, rgb(0 0 0 / 5%) 0px 1px 1px;' }}>
                                    <Box sx={{ backgroundColor: 'rgb(0, 254, 217)', borderRadius: '16px 0px 0px 16px', color: 'white', p: 1.5, display: 'flex', alignItems: 'center' }}>
                                        <InfoRoundedIcon sx={{ color: 'rgb(26, 51, 66)' }} />
                                    </Box>
                                    <Box sx={{ flex: '1 1 0%', p: 1.5, backgroundColor: 'rgb(26, 51, 66)', borderBottomRightRadius: '14px', borderTopRightRadius: '14px' }}>
                                        <Box sx={{ color: 'white', fontSize: '16px', fontWeight: '400', lineHeight: '1.5' }}>
                                            Farms are exposed to impermanent loss, be sure to do your own research.
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                // flex: "1 1 0%",
                                display: "flex",
                                justifyContent: "center",
                                height: "100%",
                                mt: { xs: 0, sm: 0, md: 4, lg: 4, xl: 4 },
                                // ml: { xl: "0%", lg: "0%", md: "0px", sm: "30%", xs: "20%" },
                            }}
                        >
                            <Box sx={{ position: "relative", maxHeight: "512px" }}>
                                {/* <Box sx={{ left:'50%' }}> */}
                                <DVXImg>
                                    <picture>
                                        <source type="image/webp" srcSet={dvx_header} />
                                        <source type="image/png" srcSet={dvx_header} />
                                        <img
                                            src={dvx_header}
                                            style={{
                                                maxWidth: "200px",
                                                width: "100%",
                                                height: "100%",
                                                maxHeight: "200px",
                                            }}
                                        />
                                    </picture>
                                </DVXImg>
                                <Box
                                    sx={{
                                        height: "100%",
                                        position: "absolute",
                                        zIndex: 1,
                                        top: "0px",
                                        left: "0px",
                                    }}
                                >
                                    <BNBImg>
                                        <picture>
                                            <source type="image/webp" srcSet={bnb_header} />
                                            <source type="image/png" srcSet={bnb_header} />
                                            <img
                                                src={bnb_header}
                                                style={{
                                                    maxWidth: "200px",
                                                    width: "100%",
                                                    height: "100%",
                                                    maxHeight: "200px",
                                                }}
                                            />
                                        </picture>
                                    </BNBImg>
                                </Box>
                                <Box
                                    sx={{
                                        height: "100%",
                                        position: "absolute",
                                        zIndex: 0,
                                        top: "0px",
                                        left: "0px",
                                    }}
                                >
                                    <BusdImg>
                                        <picture>
                                            <source type="image/webp" srcSet={busd_img} />
                                            <source type="image/png" srcSet={busd_img} />
                                            <img
                                                src={busd_img}
                                                style={{
                                                    maxWidth: "200px",
                                                    width: "100%",
                                                    height: "100%",
                                                    maxHeight: "200px",
                                                }}
                                            />
                                        </picture>
                                    </BusdImg>
                                    {/* </Box> */}
                                </Box>
                            </Box>

                            {/* <img src={dvx_header} />
                            <img src={bnb_header} /> */}
                        </Box>
                    </Box>

                </Container>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <PoolsData>
                    <PoolControls>
                        <FarmTabButtons
                            stackChange={stackChange}
                            setSearchValue={setSearchValue}
                            searchvalue={searchvalue}
                            setIsToggleview={setIsToggleview}
                        />
                    </PoolControls>
                    {istoggleview ? <FarmsTable
                        pools={filteredPool}
                        account={account}
                        userDataLoaded={userDataLoaded}
                    /> :
                        <Grid container spacing={0}>
                            {filteredPool.length !== 0 ?
                                filteredPool.map((pool, index) => (
                                    <Grid item xs={12} sm={12} md={6} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <FarmCard pool={pool} index={index} account={account} />
                                    </Grid>
                                ))
                                :
                                <Box sx={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '16px', fontWeight: '400', lineHeight: '1.5' }}>
                                    No Farms
                                </Box>
                            }

                        </Grid>
                    }
                </PoolsData>
                {idx != -1 &&
                    <FarmRoiCalculatorModal open={idx != -1} onClose={handleClose} pool={filteredPool[idx]} ></FarmRoiCalculatorModal>
                }
            </Box>
        </>
    );
};

export default Farms;
